export const ActionsSearchResult = {
	GET_SEARCH_RESULT: "get_search_result",
	LOAD_GET_SEARCH_RESULT: "load_get_search_result",
	RES_GET_SEARCH_RESULT: "res_get_search_result",
	ERR_GET_SEARCH_RESULT: "err_get_search_result",
	HYDRATE: "HYDRATE",
};

export function failureSearchResult(err) {

	return {
		type: ActionsSearchResult.ERR_GET_SEARCH_RESULT,
		err,
	};

}

export function loadSearchResult(params = {}) {

	return {
		type: ActionsSearchResult.GET_SEARCH_RESULT,
		...params,
	};

}

export function loadGetSearchResult(params = {}) {

	return {
		type: ActionsSearchResult.LOAD_GET_SEARCH_RESULT,
		...params,
	};

}

export function loadSearchResultSuccess(data) {

	return {
		type: ActionsSearchResult.RES_GET_SEARCH_RESULT,
		data,
	};

}
